






































import { clickOutside } from '~/components/directives/click-outside/click-outside-directive';
import { SfImage } from '~/components/StorefrontUi';
import { getFilterConfig } from '~/modules/catalog/category/config/FiltersConfig';
import { addBasePath } from '~/helpers/addBasePath';
import { defineComponent, ref } from '@nuxtjs/composition-api';

import type { Aggregation, AggregationOption } from '~/modules/GraphQL/types';
import { useFilters } from '~/modules/catalog/category/components/filters/useFilters';
import { IconSingleArrowLeft } from '~/components/General/icons';

export default defineComponent({
  name: 'CategoryFilters',
  components: {
    CheckboxType: () => import(
      '~/modules/catalog/category/components/filters/renderer/CheckboxType.vue'
    ),
    RadioType: () => import(
      '~/modules/catalog/category/components/filters/renderer/RadioType.vue'
    ),
    YesNoType: () => import(
      '~/modules/catalog/category/components/filters/renderer/YesNoType.vue'
    ),
    SfImage,
    IconSingleArrowLeft,
  },
  directives: { clickOutside },
  props: {
    filter: {
      type: Object as () => Aggregation,
      required: true,
    },
  },
  setup(_, { emit }) {
    const isPopupOpen = ref(false);
    const { selectFilter } = useFilters();
    const togglePopup = () => {
      isPopupOpen.value = !isPopupOpen.value;
    };
    const closePopup = () => {
      isPopupOpen.value = false;
    };
    const openPopup = () => {
      isPopupOpen.value = true;
    };
    const selectFilterEmitter = (
      filter: Aggregation,
      value: AggregationOption,
    ) => {
      emit('select-filter', { filter, value });
      closePopup();
    };
    return {
      selectFilterEmitter,
      openPopup,
      closePopup,
      selectFilter,
      isPopupOpen,
      togglePopup,
      addBasePath,
      getFilterConfig,
    };
  },
});
